export default __webpack_public_path__ + "b492f2eef1ee14cf0de78e8c8795bda0.png";